module.exports = __webpack_public_path__ + "r-v3/img/ml_121_00.d1dc3f39.jpg";